module.exports = __webpack_public_path__ + "img/webapp-development.0469d2b3.jpg";